import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faUserEdit, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { UserModel } from '../user.model';
import { UserService } from '../user.service';
import { MultiCheckboxValidator } from '../../../_common/validators/multi-checkbox.validators';
import { RoleEnum } from '../user-role.enum';
import { AuthService } from 'src/app/auth/auth.service';

export interface AddOrEditUserDialogData {
  userModel: UserModel,
  isNewUser: boolean
}

@Component({
  selector: 'user-add-or-edit-dialog',
  templateUrl: './user-add-or-edit.dialog.html',
  styleUrls: ['./user-add-or-edit.dialog.scss']
})

export class UserAddOrEditDialog implements OnInit {
  
  faUserAdd = faUserPlus;
  faUserEdit = faUserEdit;
  userFormGroup: FormGroup;
  firstNameFormControl = new FormControl('', [Validators.required]);
  lastNameFormControl = new FormControl('', [Validators.required]);
  userNameFormControl = new FormControl('', [Validators.required, Validators.email]);
  isActiveFormControl = new FormControl(true);
  rolesFormGroup: FormGroup;
  roleEnum = RoleEnum;

  constructor(
    public userService: UserService,
    public dialogRef: MatDialogRef<UserAddOrEditDialog>,
    @Inject(MAT_DIALOG_DATA) public data: AddOrEditUserDialogData,
    private formBuilder: FormBuilder,
    public authService: AuthService
  ) { }

  ngOnInit(): void {
    this.userFormGroup = this.formBuilder.group({
      firstName: this.firstNameFormControl,
      lastName: this.lastNameFormControl,
      userName: this.userNameFormControl,
      isActive: this.isActiveFormControl,
      roles: this.formBuilder.array(
        Object.keys(RoleEnum)
          .filter(key => isNaN(Number(key)) && RoleEnum[key] != RoleEnum._None)
          .map((key) => this.formBuilder.control(false)), MultiCheckboxValidator.multipleCheckboxRequireOne
      ),
    });

    if (!this.data.isNewUser) {
      this.firstNameFormControl.setValue(this.data.userModel.firstName);
      this.lastNameFormControl.setValue(this.data.userModel.lastName);
      this.userNameFormControl.setValue(this.data.userModel.userName);
      this.isActiveFormControl.setValue(this.data.userModel.isActive);

      var idx = 1;
      var fa = this.userFormGroup.get('roles')['controls'];
      fa.forEach(control => {
        this.data.userModel.roles.forEach(userRole => {
          if (userRole == idx)
            control.setValue(true);
        })
        idx++;
      });
    }
  }

  get roles(): FormArray {
    return this.userFormGroup.get('roles') as FormArray;
  }

  onOkClick(): void {
    this.data.userModel.firstName = this.firstNameFormControl.value;
    this.data.userModel.lastName = this.lastNameFormControl.value;
    this.data.userModel.userName = this.userNameFormControl.value;    
    this.data.userModel.isActive = this.isActiveFormControl.value;
    this.data.userModel.roles = [];

    let idx = 1;
    this.userFormGroup.controls.roles.value.forEach(role => {
      if (role) {
        this.data.userModel.roles.push(idx);
      }
      idx++;
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  isUserAdmin(): boolean {
    return this.authService.hasRole(RoleEnum.Administrator);
  }
}
